import{__awaiter as e}from"../../../../../node_modules/tslib/tslib.es6.js";import{shopifyStorefrontClientWrapper as s}from"../../../../../lib/clients.js";import{handleError as t}from"../../../../../lib/error-handler.js";import{gql as i}from"graphql-request";import{shopifySfCustomerToUnlikelyCustomer as r}from"../utils/serializers.js";import{STOREFRONT_METAFIELD_FRAGMENT as o}from"../../fragments/metafields.js";import{getMetafieldIdentifiers as m}from"../../../../../lib/metafields.js";import{CUSTOMER_FIELDS as l}from"../../fragments/customer.js";const c=i`
  query GetCustomer(
    $customerAccessToken: String!
    $includeMetafields: Boolean!
    $metafieldIdentifiers: [HasMetafieldsIdentifier!]!
  ) {
    customer(customerAccessToken: $customerAccessToken) {
      ${l}
      metafields(identifiers: $metafieldIdentifiers)
        @include(if: $includeMetafields) {
        ${o}
      }
    }
  }
`,n=i`
  query GetCustomer($customerAccessToken: String!) {
    customer(customerAccessToken: $customerAccessToken) {
      id
      email
    }
  }
`,d=s(((s,{token:i,includeData:o=!0,includeMetafields:l=!1,metafieldKeys:d})=>e(void 0,void 0,void 0,(function*(){const e=o?c:n,u={customerAccessToken:i},f=m(d),a=yield s.request(e,Object.assign(Object.assign({},u),{includeMetafields:(null==f?void 0:f.length)>0||l,metafieldIdentifiers:f}));return{errors:t(null==a?void 0:a.errors),customer:(null==a?void 0:a.customer)?r(a.customer):null}}))));export{d as sfCustomer};
//# sourceMappingURL=customer.js.map
